import React from "react";
import { Card, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
// import { Link } from "react-router-dom";
import "./DisplayProjects.css";

import logo from "../../../images/bk-hossain-logo.png";

const DisplayProjects = ({ project }) => {
  const { _id, projectTitle, img, technologies } = project;
  return (
    <div>
      <Col>
        <Card className="border-0 text-start image-wrapper ">
          <Card.Img
            className="project-img"
            variant="top"
            src={img}
            style={{ width: "100%", margin: "0 auto" }}
          />

          <Card.Body>
            <div className="project-style-section">
              <div className="project-style-bg"></div>
              <div className="project-motion-section">
                <img src={logo} alt="" />
              </div>
            </div>
            <Card.Title>{projectTitle}</Card.Title>

            {/* <Card.Text
              style={{
                marginTop: "5%",
                borderRadius: "15px",
              }}
            >
              <p>{brief}</p>
            </Card.Text> */}

            <Card.Text
              style={{
                marginTop: "5%",
                borderRadius: "15px",
              }}
            >
              <p>
                <strong>Technologies:</strong> {technologies}
              </p>
            </Card.Text>

            <span>
              <br />
              <Link to={`/project-details/${_id}`}>
                <button className="bk-button">Details</button>
              </Link>
            </span>
          </Card.Body>
        </Card>
      </Col>
    </div>
  );
};

export default DisplayProjects;
